export const LIGHT_THEME = {
  background: '#F4F1EC',
  text: '#111114',
};

export const DARK_THEME = {
  background: '#111114',
  text: '#F4F1EC',
};

export const PRIORITY_COLORS = {
  high: '#E25A3C',
  medium: '#C68A3A',
  low: '#5C8A6B',
};

export const CATEGORY_COLORS = {
  personal: '#7A6CCF',
  work: '#3E6FB8',
  school: '#2F8A86',
  fitness: '#C9683A',
  other: '#86868B',
};

export const CATEGORY_LABELS = {
  personal: 'Personal',
  work: 'Work',
  school: 'School',
  fitness: 'Fitness',
  other: 'Other',
};

export const CATEGORY_KEYS = Object.keys(CATEGORY_LABELS);
